<template>
    <seccion-datos titulo="Autofacturación" :botonGuardar="false">
        <div class="row">
            <div class="col-md-12">
                <p class="text-muted">
                    Formato de las facturas en PDF que envía esta compañía. Sin modelo asignado, sus autofacturas no se pueden importar.
                </p>
                <Dropdown v-model="modelo"
                          :options="modelosEtiquetados"
                          optionLabel="etiqueta"
                          optionValue="modelo"
                          showClear
                          :placeholder="modelos.length ? 'Sin modelo asignado' : 'No hay modelos disponibles'"
                          :disabled="guardando || !modelos.length"
                          @change="guardar()"
                          class="w-100" />
                <p v-if="error" class="text-danger" style="margin-top:8px">{{ error }}</p>
            </div>
        </div>
    </seccion-datos>
</template>

<script>
import { PwgsApi } from '../../../../../services/PwgsApi';
import Dropdown from 'primevue/dropdown';

export default {
    components: { Dropdown },
    props: {
        datos: {
            type: Object
        },
        id: {
            default: 0,
        }
    },
    data() {
        return {
            modelos: [],
            modelo: null,
            guardando: false,
            error: '',
        };
    },
    methods: {
        async cargarModelos() {
            try {
                const api = new PwgsApi();
                const resp = await api.get('autofacturas/modelos');
                this.modelos = resp.datos || [];
            } catch (e) {
                this.error = 'No se han podido cargar los modelos.';
            }
        },
        cargarAsignado() {
            this.modelo = (this.datos && this.datos.modelo_autofactura) ? this.datos.modelo_autofactura : null;
        },
        async guardar() {
            this.guardando = true;
            this.error = '';
            try {
                const api = new PwgsApi();
                await api.put('companias/' + this.id, { modelo_autofactura: this.modelo || '' });
            } catch (e) {
                this.error = 'No se ha podido guardar el modelo.';
                this.cargarAsignado();
            }
            this.guardando = false;
        }
    },
    computed: {
        modelosEtiquetados() {
            return this.modelos.map(m => ({
                modelo: m.modelo,
                etiqueta: m.modelo.charAt(0).toUpperCase() + m.modelo.slice(1)
            }));
        }
    },
    mounted() {
        this.cargarModelos();
        this.cargarAsignado();
    },
    watch: {
        datos() {
            this.cargarAsignado();
        }
    }
}
</script>